import { FC } from "react"
import Hidden from "@components/Hidden";
import IOSSwitch from "@components/IOSSwitch"
import NumericPriceInput from "@components/Inputs/NumericPriceInput";
import {  FormControlLabel } from "@mui/material";
import { EventConditionsComponentProps } from '@pages/makeEvent/types/index.ts'
import s from "./styles.module.css"


const EventConditionsComponent: FC<EventConditionsComponentProps> = ({ formik }) => {

	const priceInputChangeHandler = (value:number) => {
    formik.setFieldValue("event_price", value)
  }

  return (
		<div className={s.action}>
        <div className={s.switch_item}>
          <p>Выводить в поиске</p>
          <FormControlLabel
            style={{ margin: 0 }}
            control={<IOSSwitch sx={{ m: 1 }} />}
            label={null}
            onChange={formik.handleChange("show_event_in_search")}
            value={formik.values.show_event_in_search}
            checked={formik.values.show_event_in_search}
          />
        </div>
        <div className={s.switch_item}>
          <p>Наличие алкоголя</p>
          <FormControlLabel
            style={{ margin: 0 }}
            control={<IOSSwitch sx={{ m: 1 }} />}
            label={null}
            onChange={() => {
              formik.setFieldValue("has_alcohol", !formik.values.has_alcohol)
              formik.setFieldValue(
                "is_eighteen_year_limit",
                !formik.values.has_alcohol || formik.values.is_eighteen_year_limit,
              )
            }}
            value={formik.values.has_alcohol}
            checked={formik.values.has_alcohol}
          />
        </div>
        <div className={s.switch_item}>
          <p>Разослать всем по интересам</p>
          <FormControlLabel
            style={{ margin: 0 }}
            control={<IOSSwitch sx={{ m: 1 }} />}
            label={null}
            onChange={() => {
              formik.setFieldValue(
                "send_to_all_users_by_interests",
                !formik.values.send_to_all_users_by_interests,
              )

            }}
            value={formik.values.send_to_all_users_by_interests}
            checked={formik.values.send_to_all_users_by_interests}
          />
        </div>
        <div className={s.switch_item}>
          <p>
            Ограничение <b>18+</b>
          </p>
          <FormControlLabel
            style={{ margin: 0 }}
            control={<IOSSwitch sx={{ m: 1 }} />}
            label={null}
            onChange={() => {
              formik.setFieldValue(
                "is_eighteen_year_limit",
                !formik.values.is_eighteen_year_limit,
              )
              formik.setFieldValue(
                "has_alcohol",
                !formik.values.is_eighteen_year_limit && false,
              )

            }}
            value={formik.values.is_eighteen_year_limit}
            checked={formik.values.is_eighteen_year_limit}
          />
        </div>

        <div className={s.switch_item}>
          <p>Платно</p>
          <FormControlLabel
            style={{ margin: 0 }}
            control={<IOSSwitch sx={{ m: 1 }} />}
            label={null}
            onChange={() => {
              formik.setFieldValue("is_free", !formik.values.is_free)
            }}
            value={!formik.values.is_free}
            checked={!formik.values.is_free}
          />

      </div>
        <Hidden isVisible={!formik.values.is_free} animation="grow">
          <div className={s.price_item} >
            <p>Цена</p>
            <NumericPriceInput
						  value={ formik.values.is_free ? undefined : formik.values['event_price']}
							onChange={priceInputChangeHandler} />
          </div>
        </Hidden>
      </div>
	)
}

export default EventConditionsComponent